import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { ShareSquadshotPage } from './share-squadshot.page';
import { SquadCastComponentsModule } from '../../components/squadcast.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild([
      {
        path: '',
        component: ShareSquadshotPage,
      },
    ]),
    SquadCastComponentsModule,
  ],
  declarations: [ShareSquadshotPage],
})
export class ShareSquadshotModule {}
